import { useMutation } from "react-query";
import { useSnackbar } from "notistack";

import { uploadFile } from "../../api/generic-api";
import { EmailPayload } from "../../models";

export const useSendCustomerAppointment = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (payload: { scheduleId: string; emailPayload: EmailPayload }) =>
      uploadFile<EmailPayload>(
        `emails/customer-appointment/${payload.scheduleId}`,
        payload.emailPayload
      ),
    {
      onSuccess: () => {
        enqueueSnackbar("Customer Appointment Sent", { variant: "success" });
      },
      onError: () => {
        enqueueSnackbar("Customer Appointment Send Error", {
          variant: "error",
        });
      },
    }
  );
};
